import { EffectCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { playlistApi } from '../../api/swagger'
import { useAppSnackbar } from '../useAppSnackbar'
import useLoadingContext from '../useLoadingContext'
import { useLoadingIds } from '../useLoadingIds'

interface DeletePlaylistItemHookResponse {
  deletePlaylistItem: EffectCallback
}

export const useDeletePlaylistItem = (
  playlistItemKey?: number,
  onSuccess?: () => void
): DeletePlaylistItemHookResponse => {
  const { t } = useTranslation()
  const { handleError, handleMessage } = useAppSnackbar()
  const {
    Playlist: { deletePlaylistItem: deletePlaylistItemLoadingId },
  } = useLoadingIds()

  const defaultErrorMessage = t(
    'Playlist.UseDeletePlaylistItem.Actions.DeletePlaylistItemFailure',
    'An unknown error occurred requesting to delete Playlist Item.'
  )

  const deletePlaylistItem = async () => {
    if (!playlistItemKey) return

    try {
      await playlistApi.deletePlaylistItem({ playlistItemKey })
      handleMessage(
        t(
          'Playlist.UseDeletePlaylistItem.Actions.DeletePlaylistItemSuccess',
          'Playlist Item has successfully been deleted.'
        )
      )

      onSuccess?.()
    } catch (error) {
      await handleError(error, defaultErrorMessage)
    }
  }
  const { triggerFetch } = useLoadingContext({
    asyncFunction: deletePlaylistItem,
    loadingId: deletePlaylistItemLoadingId,
  })

  return { deletePlaylistItem: triggerFetch }
}
